import { Target } from '../@types';

const targetsForPrivacy: Target[] = [
  { value: 'brandName', type: 'text', isAPI: false },
  { value: 'status', type: 'text', isAPI: false },
];

export default targetsForPrivacy;
